var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-modal',{attrs:{"title":"","show-modal-content":_vm.showLoginModal,"max-width":1034},on:{"close":_vm.resetStates}},[_c('div',{attrs:{"slot":"modal-content"},slot:"modal-content"},[_c('login-modal-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }